<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <form
    *ngIf="entityForm"
    class="card-children-general"
    [formGroup]="entityForm"
    (ngSubmit)="completeHandler()">
    <mat-form-field>
      <input
        matInput
        required
        placeholder="Codice Unico"
        formControlName="codiceUnico">
      <mat-error *ngIf="entityForm?.controls?.codiceUnico.hasError('required')">Codice Unico obbligatorio</mat-error>
      <mat-error *ngIf="entityForm?.controls?.codiceUnico.hasError('duplicate')">Codice Unico già esistente</mat-error>
      <mat-hint>
        {{ 'Modifica il codice unico in maniera che non sia uguale a quello della scheda madre' }}
      </mat-hint>
    </mat-form-field>
    <app-input-vocabulary-autocomplete
      *ngIf="entityForm?.controls?.tipoOperaFiglia"
      formControlName="tipoOperaFiglia"
      [vocabularyName]="'V_TipoOperaFiglia'"
      [placeholder]="'Tipo opera figlia'">
    </app-input-vocabulary-autocomplete>
    <mat-form-field>
      <input
        matInput
        placeholder="Numero Esemplare"
        formControlName="numeroEsemplare">
    </mat-form-field>
    <mat-form-field formGroupName="SGT">
      <input
        matInput
        placeholder="Titolo soggetto (SGTT)"
        formControlName="SGTT">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Ente schedatore (ESC)"
        formControlName="ESC">
    </mat-form-field>
    <div class="card-children-repeatable">
      <app-mtc-form [form]="entityForm?.get('MTC')"></app-mtc-form>
    </div>
    <div class="card-children-repeatable">
      <app-mis-form [form]="entityForm?.get('MIS')"></app-mis-form>
    </div>

    <div class="card-children-actions">
      <button
        mat-button
        mat-raised-button
        color="primary"
        type="submit">
        {{ mainActionLabel }}
      </button>
    </div>
  </form>
</mat-dialog-content>
